export interface Act {
  id: number;
  createDt: string;
  signDt?: string;
  actPeriod: string;
  actNum: string;
  stateCode: ActStateCodes;
  stateName?: string;
  osiId: number;
  osiName?: string;
  osiIdn?: string;
  osiAddress?: string;
  osiPhone?: string;
  osiRegistrationDate?: string;
  apartCount?: number;
  planAccuralId: number;
  amount: number;
  comission: number;
  debt: number;
  tariff: number;
  actDateStr?: string;
  /**
   * OSI-818: сумма строк акта (вычисляется на бэкенде, Act.TotalItemsAmount).
   * Поле приходило и раньше — таблицы выводят именно его, — но в типе не было описано.
   * Может быть null, если у акта нет строк.
   */
  totalItemsAmount?: number | null;
  /**
   * OSI-818: id общего акта по БИН/ИИН, в состав которого входит этот акт.
   * null / отсутствует — акт самостоятельный. Акт из неподписанного общего
   * отдельно подписать нельзя: подписывается только весь общий акт целиком.
   */
  combinedActId?: number | null;
}

export enum ActStateCodes {
  CREATED = 'CREATED',
  SIGNED = 'SIGNED',
  PROV = 'PROV'
}

export interface ActDoc {
  id: number;
  docTypeCode: DocTypeCodes;
  docTypeNameRu?: string;
  docTypeNameKz?: string;
  scan: Scan;
}

export enum DocTypeCodes {
  UDL = 'UDL',
  REGISTRATION = 'REGISTRATION',
  SPR_REG_OSI = 'SPR_REG_OSI',
  SIGNED_CONTRACT = 'SIGNED_CONTRACT',
  TECHPASSPORT1LIST = 'TECHPASSPORT_1LIST',
  SIGNED_ACT = 'SIGNED_ACT',
  ACCOUNT_REPORT_MONTHLY = 'ACCOUNT_REPORT_MONTHLY'
}

export interface Scan {
  id: number;
  fileName: string;
}

/**
 * OSI-818: состояние общего акта по БИН/ИИН. ANNULLED в кабинет не приходит
 * (Core отдаёт по дому только CREATED и SIGNED), поэтому в перечислении его нет.
 */
export enum CombinedActStateCodes {
  CREATED = 'CREATED',
  SIGNED = 'SIGNED'
}

/** OSI-818: строка состава общего акта — акт одного дома группы. */
export interface CombinedActItem {
  actId: number;
  osiId: number;
  osiName?: string;
  osiAddress?: string;
  actNum: string;
  /** Сумма строк акта — то же, что `Act.totalItemsAmount` в таблицах. */
  amount: number | null;
  stateCode: ActStateCodes | string;
}

/**
 * OSI-818: общий акт по БИН/ИИН — акты нескольких домов одного БИН/ИИН за период,
 * подписываемые одним PDF. Виден в «Актах» каждого дома группы.
 */
export interface CombinedAct {
  id: number;
  /** БИН/ИИН, по которому сгруппированы дома. */
  idn: string;
  actPeriod: string;
  stateCode: CombinedActStateCodes;
  createDt: string;
  signDt?: string | null;
  /** Итоговая сумма по всем актам состава. */
  totalAmount: number | null;
  /** Сохранён ли на бэкенде сформированный PDF общего акта. */
  pdfStored: boolean;
  items: CombinedActItem[];
}
